import React from 'react';

const VIDEO_EXTENSIONS = /\.(mp4|mov|webm|ogg|avi|mkv|m4v)(\?|$)/i;
const buttonStyle = {
  width: 44, height: 44, minWidth: 44, padding: 0, border: 'none', borderRadius: 4,
  overflow: 'hidden', position: 'relative', cursor: 'pointer', background: '#f3f4f6',
  boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
};

export default function ThumbnailStrip({ images = [], onOpen, label = 'Attachment' }) {
  const shown = images.slice(0, 3);
  const remaining = Math.max(0, images.length - shown.length);
  const open = (event, index) => {
    event.stopPropagation();
    if (typeof onOpen === 'function') onOpen(index);
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      {shown.map((image, index) => {
        const src = typeof image === 'string' ? image : image.url;
        const isVideo = VIDEO_EXTENSIONS.test(src || '');
        return (
          <button key={index} type="button" aria-label={`Open ${label.toLowerCase()} ${index + 1} of ${images.length}`}
            style={buttonStyle} onClick={(event) => open(event, index)}>
            {isVideo ? <>
              <video src={src} muted playsInline preload="metadata" aria-hidden="true"
                style={{ width: '100%', height: '100%', objectFit: 'cover', pointerEvents: 'none' }} />
              <span aria-hidden="true" style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', background: 'rgba(0,0,0,0.15)' }}>▶</span>
            </> : <img src={src} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
          </button>
        );
      })}
      {remaining > 0 && <button type="button" aria-label={`Open ${remaining} more attachments`}
        style={{ ...buttonStyle, color: '#6b7280' }} onClick={(event) => open(event, shown.length)}>+{remaining}</button>}
    </div>
  );
}
